import {getRequest} from "./getRequest";

export const validateVAT = async (vat: string) => {
    vat = vat.replace('-', '');
    return getRequest('/api/tools/ValidateVATFormat/' + vat)
};